<template>
  <footer class="site-footer">
    <div class="container">
      <div class="content">
        <div class="col1">
          <p class="small">
            <KaleiderSVG class="logo"/>
          </p>

          <slot></slot>

        </div>

        <div class="col2">
          <div class="partnership-logos">
            <div v-for="(i, index) in images" v-bind:key="index" class="footer-image">
              <img :src="i.image.meta.download_url" :alt="i.image.title" :title="i.image.title" />
            </div>
          </div>
        </div>
      </div>

      <div class="copyright">
        <p class="small">&copy; Copyright Kaleider</p>
      </div>
    </div>
  </footer>
</template>

<script>
import KaleiderSVG from "@/assets/kaleider.svg"

export default {
  name: "site-footer",
  components: {
    KaleiderSVG,
  },
  props: ["images"],
}
</script>

<style lang="scss" scoped>
  .site-footer {
    padding: 75px 0;
    background-color: $color-grey;

    .content {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: flex-start;

      @media screen and (max-width: $break-mobile) {
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
      }


      .logo {
        max-width: 250px;
      }

      p:last-child {
        margin-bottom: 0;
        padding-bottom: 0;
      }

      > div {
        width: calc(50% - 75px);
        @media screen and (max-width: $break-mobile) {
          width: initial;
        }
      }
    }

    .partnership-logos {
      display: flex;
      flex-flow: row wrap;
      align-items: center;
      justify-content: flex-end;

      @media screen and (max-width: $break-mobile) {
        margin-top: 1em;
        justify-content: flex-start;
      }


      .footer-image {
        margin: 0 0 1em 1em;
        max-width: calc(50% - 1em);

        @media screen and (max-width: $break-mobile) {
          margin: 0 1em 1em 0;
        }

        img {
          display: block;
          max-height: 100px;
          height: auto;
          width: 100%;
        }
      }

      svg {
        width: 45%;
      }
    }

    .copyright {
      margin-top: 100px;
      @media screen and (max-width: $break-mobile) {
        margin-top: 2em;
      }
    }
  }
</style>
